<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col cols="12" class="p-0">
          <TopBarMember class="mb-0 mb-sm-3" />
        </b-col>
      </b-row>
    </b-container>
    <b-container class="px-0 px-sm-3 overflow-hidden">
      <b-card
        header-bg-variant="dark"
        header-border-variant="dark"
        header-text-variant="white"
        header-tag="header"
        body-bg-variant="light"
        border-variant="dark"
        class="main-card"
        body-class="p-1 p-sm-3"
      >
        <template #header class="card-header px-0">
          <router-link to="/">
            <i class="fas fa-chevron-left"></i> หน้าหลัก
          </router-link>
        </template>
        <b-row class="mb-2">
          <b-col>
            <b-card
              body-class="p-2  d-flex flex-column flex-sm-column flex-md-row justify-content-between"
              class="shadow-sm"
              border-variant="white"
            >
              <h5 class="mb-0 mt-1">
                <i class="fas fa-gifts"></i> Jackpot
              </h5>
              <b-button
                size="sm"
                variant="outline-secondary"
                v-b-modal.modal-rules
                class="py-1"
              >กติกา & วิธีเล่น</b-button>
              <b-modal
                id="modal-rules"
                size="lg"
                title="กติกา"
                header-class="text-mitr bg-gold"
                header-bg-variant="warning"
              >
                <h4 class="font-mitr">วิธีการแทง {{getAppName}} JACKPOT</h4>
                <p>
                    <ol>
                  <li>เปิดรับเเทงออนไลน์ตลอด 24 ชั่วโมง สามารถเเทงได้ล่วงหน้าตามเวลาหวยรัฐบาลไทยเปิดรับแทง</li>
                  <li>{{getAppName}} JACKPOT จะออกหมายเลขตามสลากกินเเบ่งรัฐบาลไทย ปิดรับเเทงก่อนวันหวยรัฐบาลออกเวลา 14:00น. ของทุกงวด</li>
                  <li>เลือกหมายเลขจาก 0 ถึง 9 “ซ้ำกันได้” กรอกลงในเเต่ละช่อง</li>
                  <li>ทุกๆยอดเเทง 50 บาท ต่อ 1 โพยจะได้รับเเต้ม 1 Reward <br>
                    ตัวอย่าง เเต้ม Reward ที่จะได้รับ
                    <ul>
                        <li>ยอดเเทงน้อยกว่า 50 บาทต่อ 1 โพย จะไม่ได้รับเเต้ม Reward</li>
                        <li>ยอดเเทง 50 บาทต่อ 1 โพย จะได้รับ 1 Reward</li>
                        <li>ยอดเเทง 70 บาทต่อ 1 โพย จะได้รับ 1 Reward</li>
                        <li>ยอดเเทง 140 บาทต่อ 1 โพยจะได้รับ 2 Reward</li>
                    </ul>
                        สงวนสิทธิ์รับเเต้ม 1 Reward Point ต่อ 1 โพยที่มียอดเเทงมากกว่า 50 บาทขึ้นไป
                  </li>
                  <li>ใช้ เเต้ม 1 Reward ในการเเทง {{getAppName}} JACKPOT ได้ 1 หมายเลข</li>
                  <li>เเต้ม Reward จะถูกรีเซ็ต(เริ่มนับใหม่) ทุกวันที่ 16 ของเดือน
                  <font color="red">!!โปรดใช้เเต้ม Reward ของท่านให้หมดก่อนวันที่ 16 ของเดือน</font></li>
                    </ol>
                </p>
                <h4 class="font-mitr">เงินรางวัล {{getAppName}} JACKPOT</h4>
                <p>
                    <ol>
                  <li>เงินรางวัล {{getAppName}} JACKPOT ในเเต่ตั้งต้น 1,000,000 บาท</li><li>เงินรางวัลที่จะสะสมเพิ่มขึ้นในแต่ละงวดคือ 500,000 บาท</li>
                  <li>ในเเต่ละงวดถ้าไม่มีผู้ถูกรางวัลที่ 1 เงินรางวัลจะถูกสะสมเป็นเงินรางวัล {{getAppName}} JACKPOT เพิ่มขึ้นเรื่อยๆ</li><li>กรณีมีผู้ถูกรางวัล {{getAppName}} JACKPOT หลายคนเงินรางวัลทั้งหมดจะถูกเเบ่งเท่ากับจำนวนผู้ถูกรางวัลทั้งหมด<br>
                  ตัวอย่าง
                  <br />
นาย A, นาย B, นาย C เเละ นาย D ถูกรางวัล {{getAppName}} JACKPOT จำนวนเงินรางวัล 1,000,000 บาท นาย A, นาย B, นาย C เเละ นาย D จะได้เงินรางวัลเเบ่งกันคนละ 1,000,000 หาร 4 เท่ากับ 250,000 บาท</li>
                  </ol>
                </p>
            <template #modal-footer>
              <div class="w-100">
                <b-button
                  variant="secondary"
                  class="float-right golden-btn"
                  @click="$bvModal.hide('modal-rules')"
                >ฉันเข้าใจและยอมรับ</b-button>
              </div>
            </template>
              </b-modal>
            </b-card>
          </b-col>
        </b-row>
        <b-row class="mx-0 px-0">
          <b-col class="mt-0 mb-1 py-1 px-1" cols="4">
            <router-link
              :class="((page == 'result' || page === undefined) ? 'btn-warning ' : 'btn-outline-warning ') + 'btn btn-block px-0'"
              to="/member/jackpot"
            >
              <i class="fas fa-award"></i>
              <br />ผลแจ็คพอต
            </router-link>
          </b-col>
          <b-col class="mt-0 mb-1 py-1 px-1" cols="4">
            <router-link
              :class="(page == 'tang' ? 'btn-warning ' : 'btn-outline-warning ') + 'btn btn-block px-0'"
              to="/member/jackpot/tang"
            >
              <i class="fas fa-calculator"></i>
              <br />แทงแจ็คพอต
            </router-link>
          </b-col>
          <b-col class="mt-0 mb-1 py-1 px-1" cols="4">
            <router-link
              :class="(page == 'poy' ? 'btn-warning ' : 'btn-outline-warning ') + 'btn btn-block px-0'"
              to="/member/jackpot/poy"
            >
              <i class="fas fa-tasks"></i>
              <br />รายการที่แทง
            </router-link>
          </b-col>
        </b-row>
        <Result v-if="page === undefined" :lottoInfo="lottoInfo"/>
        <Poy v-if="page === 'poy'" :lottoType="lottoType" :lottoInfo="lottoInfo" />
        <Tang v-if="page === 'tang'" lottoType="29" />
      </b-card>
    </b-container>
    <FooterIndex class="mt-3" />
  </div>
</template>

<script>
import { Component, Vue, Prop } from "vue-property-decorator";
import { mapGetters } from "vuex";
import axios from "axios";

// Include Component
import TopBarMember from "@/components/TopBarMember.vue";
import Result from "@/components/member/jackpot/Result.vue";
import Poy from "@/components/member/jackpot/Poy.vue";
// import Tang from "@/components/member/lotteryset/hanoi/Tang.vue";
import Tang from "@/components/member/jackpot/Tang2.vue";
import FooterIndex from "@/components/Footer.vue";

export default {
  name: 'Jackpot',
  props: ['page'],
  components: {
    TopBarMember,
    Result,
    Poy,
    Tang,
    FooterIndex
  },
  data() {
    return {
      filter: "TODAY",
      transactions: [
        {
          number: "347387676",
          type: "BET",
          by: "aloneruay",
          to: "ระบบ",
          amount: 300,
          balance: 239,
          date: "11/04/2021 23:39",
          notes: "adfdsfd"
        },
        {
          number: "347387675",
          type: "BET",
          by: "aloneruay",
          to: "ระบบ",
          amount: 300,
          balance: 239,
          date: "11/04/2021 23:39",
          notes: null
        }
      ],
      transactionTypes: [
        {
          code: "BET",
          title: "แทงพนัน"
        }
      ],
      paymentMethods: [
        {
          code: "ATM",
          title: "ATM",
          description: "โอนจากตู้กดเงินสด"
        },
        {
          code: "CDM",
          title: "CDM",
          description: "ฝากผ่านตู้ฝากเงินสด"
        },
        {
          code: "CTC",
          title: "Counter Cashier",
          description: "ฝากเงินผ่านเคาน์เตอร์ธนาคาร"
        },
        {
          code: "INB",
          title: "Internet Banking",
          description: "โอนเงินผ่านหน้าเว็บไซต์"
        },
        {
          code: "MBB",
          title: "Mobile Banking",
          description: "โอนเงินผ่านแอพมือถือ"
        }
      ],
      lottoInfo: {},
      lottoType: 29
    };
  },
  mounted() {
    this.getLottoInfo();
  },   
  methods: {
    getLottoInfo() {
      axios.post(this.getApiUrl + "/jackpot/available",
          {
          },
          {
            headers: {
              "Content-Type": "application/json",
              token: this.getAccessToken,
              username: this.getUsername
            }
          }
        )
        .then(response => {
          this.lottoInfo = response.data.data;
          console.log("getLottoInfo",this.lottoInfo);
        });
    } 
  },
  computed: {
    ...mapGetters({
      getAccessToken: "getAccessToken",
      getUsername: "getUsername",
      getCashAmount: "getCashAmount",
      getLottoType: "getLottoType",
      getApiUrl: "getApiUrl",
      getAppName: "getAppName"
    })
  }   
}
</script>

<style lang="scss" scoped>
.main-card {
  min-height: calc((100vh - 104px) - 49px);
}

.card-header {
  font-size: 90%;
  line-height: 90%;

  a {
    color: #bbbbbb;

    &:hover {
      color: #bd841b;
      text-decoration: none;
    }
  }
}

.bg-gold {
  background-image: linear-gradient(
    160deg,
    #a54e07,
    #b47e11,
    #fef1a2,
    #bc881b,
    #a54e07
  ) !important;
  border: 1px solid #a55d07;
  text-shadow: rgb(0 0 0) 2px 0px 0px, rgb(0 0 0) 1.75517px 0.958851px 0px,
    rgb(0 0 0) 1.0806px 1.68294px 0px, rgb(0 0 0) 0.141474px 1.99499px 0px,
    rgb(0 0 0) -0.832294px 1.81859px 0px, rgb(0 0 0) -1.60229px 1.19694px 0px,
    rgb(0 0 0) -1.97998px 0.28224px 0px, rgb(0 0 0) -1.87291px -0.701566px 0px,
    rgb(0 0 0) -1.30729px -1.5136px 0px, rgb(0 0 0) -0.421592px -1.95506px 0px,
    rgb(0 0 0) 0.567324px -1.91785px 0px, rgb(0 0 0) 1.41734px -1.41108px 0px,
    rgb(0 0 0) 1.92034px -0.558831px 0px;
  font-weight: normal !important;
}

.font-mitr {
  font-family: "Mitr", sans-serif;
}

h5 {
  color: #bd841b;
  font-weight: bold;
}

.btn {
  i {
    font-size: 25px;
  }

  &-warning {
    background-color: #bd841b;
    border-color: #bd841b;
    color: #ffffff;
  }

  &-outline-warning {
    color: #bd841b;
    border-color: #bd841b;
  }

  &:hover,
  &:focus,
  &:active {
    background-color: #bd841b;
    border-color: #bd841b;
    outline: none;
    box-shadow: none;
    color: #ffffff;
  }
}
</style>